module.exports = __webpack_public_path__ + "img/img15.42b57863.png";